import { RavenButton } from "@ravenpay/raven-bank-ui";
import Icons from "../assets/icons/icons";
import "../styles/components/ravenIconBotton.css";



// Define the allowed color types
type ButtonColors =
  | "purple-light"
  | "error-light"
  | "info-right"
  | "white-light"
  | "blue-light"
  | "green-light"
  | "orange-light"
  | "black-light"
  | "deep-green"
  | "deep-green-light"
  | "error-dark"
  | "deep-green-dark";

interface ArrowButtonProps {
  text: string;
  backgroundColor?: ButtonColors;
  textColor?: string;
  showIcon?: boolean;
  className?: string;
  paddingLeft?: string;
  paddingRight?: string;
  iconColor?: string;
  onBtnClick?: () => void;
  boxShadow?: string;
  border?: string;
}

const RavenIconButton = ({
  text,
  backgroundColor = "blue-light",
  textColor = "white",
  showIcon = true,
  
  paddingLeft,
  paddingRight,
  iconColor,
  onBtnClick,
  boxShadow,
  border,
}: ArrowButtonProps) => {
  


  

  return (
    <div className="raven_botton_general_wrap">
      <RavenButton
        className="text-4 rvn_btn"
        color="green-light"
        style={
          {
            color: textColor,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            "--box-shadow": boxShadow || null,
            "--border": border || "none",
          } as React.CSSProperties & { [key: string]: string }
        }
        onClick={() => {
          if (onBtnClick) {
            onBtnClick();
          } 
        }}
      >
         {showIcon && (
          <div className="arrow_div_cont">
            <figure className="img-box" >
              {Icons.streamKey}
            </figure>
          </div>
        )}
        {text}
       
      </RavenButton>
    </div>
  );
};
export type { ButtonColors };
export default RavenIconButton;
